// extracted by mini-css-extract-plugin
export default {"emptyButton":"RfcnRM","prefixIcon":"BtAiZy","redtext-theme":"vBsl3g","redtextTheme":"vBsl3g"};